import { Component, OnInit } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { NzStatusType, NzStepsModule } from 'ng-zorro-antd/steps'
import { NzUploadFile } from 'ng-zorro-antd/upload'
import { DevToolbarFeatureFlagService } from 'ngx-dev-toolbar'

import { create } from '../../../mocks/mirage'
import { StepMetadataComponent } from './step-metadata/step-metadata.component'
import {
  ProgressUpdateEvent,
  StepProgressComponent,
} from './step-progress/step-progress.component'
import {
  FileSelectedEvent,
  StepUploadComponent,
} from './step-upload/step-upload.component'
import { MetaDataModel, Step } from './upload-file.model'

@Component({
  selector: 'app-upload-file',
  standalone: true,
  imports: [
    TranslatePipe,
    NzStepsModule,
    StepMetadataComponent,
    StepUploadComponent,
    StepProgressComponent,
  ],
  templateUrl: './upload-file.component.html',
})
export class UploadFileComponent implements OnInit {
  public readonly Step = Step

  public currentStep: Step = Step.metadata
  public metaDataModel: MetaDataModel = {}
  public file?: NzUploadFile
  public fileLineCount: number = 0
  public totalProcess: number = 0
  public totalProcessStatus: NzStatusType = 'wait'

  // feature flags
  public showDebug: boolean = false

  public constructor(
    private readonly featureFlagsService: DevToolbarFeatureFlagService
  ) {}

  public ngOnInit(): void {
    /* istanbul ignore next -- @preserve */
    this.featureFlagsService.getForcedValues().subscribe((forcedFlags) => {
      this.showDebug = forcedFlags.some(
        (flag) => flag.id === 'showDebug' && flag.isEnabled
      )

      if (this.showDebug) {
        create()

        this.currentStep = Step.progress
        this.metaDataModel = {
          type: 'hkbw',
          source: 'Planung (GU)',
          reason: 'Update',
          note: 'Auto Test Note',
        }

        this.file = new File(
          ['foo;bar;lorem\na;b;c\n1;2;3'],
          'test-file-name.csv',
          { type: 'text/plain' }
        ) as unknown as NzUploadFile
        this.fileLineCount = 2
      }
    })
  }

  public onMetaDataModelChange(model: MetaDataModel): void {
    this.metaDataModel = model
  }

  public onMetadataStepCompleted(): void {
    this.currentStep = Step.upload
  }

  public onFileSelected(event: FileSelectedEvent): void {
    this.file = event.file
    this.fileLineCount = event.fileLineCount
  }

  public onUploadStepCompleted(): void {
    this.currentStep = Step.progress
  }

  public onBackToUpload(): void {
    this.file = undefined
    this.fileLineCount = 0
    this.currentStep = Step.upload
    this.totalProcessStatus = 'wait'
  }

  public onProgressUpdate(event: ProgressUpdateEvent): void {
    this.totalProcess = event.totalProcess
    this.totalProcessStatus = event.totalProcessStatus
  }
}
